import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Constants } from '../../common/constants';
import { Global } from '../../common/global';
import { IModuleCompanyView } from '../../services/api/api-model';
import { DataService } from '../../services/api/data.service';
import { StaticDataService } from '../../services/api/static-data.service';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { SessionService } from '../../services/session/session.service';
import { PriceFormatPipe } from '../pipes/price-format.pipe';

@Component({
  selector: 'app-module-check',
  templateUrl: './module-check.component.html'
})
export class ModuleCheckComponent implements OnInit, OnDestroy {
  private moduleIdValue: number;
  @Input()
  get moduleId(): number {
    return this.moduleIdValue;
  }

  set moduleId(value: number) {
    if (value !== this.moduleIdValue) {
      this.moduleIdValue = value;

      if (this.currentModules && this.currentModules.length > 0) {
        this.onGetModulesViewComplete();
      }
    }
  }

  @Input() noPopup: boolean;
  @Input() dialogWidth: number;
  @Input() companyOption = false;
  @Output() showDialog: EventEmitter<void> = new EventEmitter<void>();
  @Output() hasModuleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() public get hasModule(): boolean {
    return this.hasModuleValue;
  }
  public set hasModule(value: boolean) {
    if (value !== this.hasModuleValue) {
      this.hasModuleValue = value;
    }
  }

  public get IsGreenlandCompany(): boolean {
    return Global.COMPANY && Global.COMPANY.CountryId === Constants.GREENLAND_COUNTRY_ID;
  }

  public modulePrice: number;
  public moduleName: string;
  public activateModuleDialogVisible = false;
  public moduleActivatedDialogVisible = false;
  private hasModuleValue = false;
  private currentModules: IModuleCompanyView[] = [];
  public moduleActivatedDialogMessage = 'AccountModules.ReloginForChanges';

  constructor(
    private sessionService: SessionService,
    private staticDataService: StaticDataService,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private priceFormatPipe: PriceFormatPipe
  ) {}

  public get branding() {
    return environment.branding;
  }

  public ngOnInit(): void {
    this.staticDataService.moduleCompanyView
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((modules: IModuleCompanyView[]) => {
        if (modules && modules.length > 0 && this.currentModules.length === 0) {
          this.currentModules = modules;
          this.onGetModulesViewComplete();
        }
      });
  }
  public onGetModulesViewComplete(): void {
    const module: IModuleCompanyView =
      this.currentModules && this.currentModules.length
        ? this.currentModules.find((m: IModuleCompanyView) => m.ModuleId === this.moduleId)
        : undefined;
    if (module) {
      this.hasModule = module.IsEnabled;
      this.modulePrice = module.ModulePrice;
      this.moduleName = module.ModuleName;
    } else {
      this.hasModule = false;
    }
    setTimeout(() => {
      this.hasModuleChange.emit(this.hasModule);
    });
  }

  private ngUnsubscribe: Subject<{}> = new Subject();
  public IsGreenlandCompanyactivateModuleDialogVisible = false;

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  //format the price before it gets passed as a translation param
  public get translationParams(): any {
    return {
      moduleName: this.moduleName,
      modulePrice:
        this.priceFormatPipe.transform(this.modulePrice, true) === 'Price.Free'
          ? '0,-'
          : this.priceFormatPipe.transform(this.modulePrice, true)
    };
  }

  public get isFullAdmin(): boolean {
    return this.sessionService.role.IsFullAdmin;
  }

  public onClick(): void {
    if (!this.hasModule) {
      if (!this.IsGreenlandCompany) {
        this.activateModuleDialogVisible = !this.noPopup;
        this.showDialog.emit();
      } else {
        this.IsGreenlandCompanyactivateModuleDialogVisible = !this.noPopup;
        this.showDialog.emit();
      }
    }
  }

  private dialogvisible(): boolean {
    return !this.noPopup && this.IsGreenlandCompany;
  }

  public reloadPage(): void {
    window.location.reload();
  }

  public onActivateModuleDialogAction(action: string): void {
    switch (action) {
      case 'ViewPackages':
        this.sessionService.NavigateTo('tabs.company.modules');
        break;
      case 'ActivateModule':
        this.dataService.Modules_EnableModule(this.moduleId).subscribe(
          (message: string) => {
            if (message) {
              this.moduleActivatedDialogMessage = message;
            }
            this.staticDataService.loadStaticData().then(() => {
              this.moduleActivatedDialogVisible = true;
            });
          },
          (): void => {
            // this.reloadPage();
          }
        );
        break;
    }
  }

  public onIsGreenlandCompanyActivateModuleDialogAction(event: any): void {}
}
